export const FEATURE_PERMISSIONS = {
    SALES_READ: "org:sales:read",
    SALES_WRITE: "org:sales:write",
    SALES_EXPORT: "org:sales:export",
    QUOTES_READ: "org:quotes:read",
    QUOTES_WRITE: "org:quotes:write",
    REMITOS_READ: "org:remitos:read",
    REMITOS_WRITE: "org:remitos:write",
    ORDERS_READ: "org:orders:read",
    ORDERS_WRITE: "org:orders:write",
    ORDERS_ADMIN: "org:orders:admin",
    ORDERS_PICKING: "org:orders:picking",
    PREPARACION_WRITE: "org:preparacion:write",
    PRODUCTS_READ: "org:products:read",
    PRODUCTS_WRITE: "org:products:write",
    PRODUCTS_EXPORT: "org:products:export",
    INVENTORY_READ: "org:inventory:read",
    INVENTORY_WRITE: "org:inventory:write",
    INVENTORY_EXPORT: "org:inventory:export",
    STOCK_MOVEMENTS_READ: "org:stock_movements:read",
    STOCK_MOVEMENTS_WRITE: "org:stock_movements:write",
    STOCK_MOVEMENTS_EXPORT: "org:stock_movements:export",
    PRICES_READ: "org:prices:read",
    PRICES_WRITE: "org:prices:write",
    CUSTOMERS_READ: "org:customers:read",
    CUSTOMERS_WRITE: "org:customers:write",
    CUSTOMERS_EXPORT: "org:customers:export",
    PURCHASES_READ: "org:purchases:read",
    PURCHASES_WRITE: "org:purchases:write",
    PURCHASES_EXPORT: "org:purchases:export",
    PURCHASE_ORDERS_READ: "org:purchase_orders:read",
    PURCHASE_ORDERS_WRITE: "org:purchase_orders:write",
    SUPPLIERS_READ: "org:suppliers:read",
    SUPPLIERS_WRITE: "org:suppliers:write",
    SUPPLIERS_EXPORT: "org:suppliers:export",
    REPORTS_READ: "org:reports:read",
    REPORTS_EXPORT: "org:reports:export",
    REPORTS_IMPOSITIVO_READ: "org:reports_impositivo:read",
    REPORTS_VENTAS_READ: "org:reports_ventas:read",
    REPORTS_INVENTARIO_READ: "org:reports_inventario:read",
    REPORTS_FINANCIEROS_READ: "org:reports_financieros:read",
    CONTABILIDAD_READ: "org:contabilidad:read",
    CONTABILIDAD_WRITE: "org:contabilidad:write",
    CONTABILIDAD_EXPORT: "org:contabilidad:export",
    TREASURY_READ: "org:treasury:read",
    TREASURY_WRITE: "org:treasury:write",
    TREASURY_EXPORT: "org:treasury:export",
    CHECKS_READ: "org:checks:read",
    CHECKS_WRITE: "org:checks:write",
    CHECKS_EXPORT: "org:checks:export",
    TRANSFERS_READ: "org:transfers:read",
    TRANSFERS_WRITE: "org:transfers:write",
    TRANSFERS_EXPORT: "org:transfers:export",
    SETTINGS_WRITE: "org:settings:write",
    INTEGRATIONS_WRITE: "org:integrations:write",
    CHAT_WRITE: "org:chat:write",
    IMPORT_WRITE: "org:import:write",
};
/** Integration management does not imply access to other organization settings. */
export const INTEGRATION_MANAGEMENT_PERMISSIONS = [
    FEATURE_PERMISSIONS.SETTINGS_WRITE,
    FEATURE_PERMISSIONS.INTEGRATIONS_WRITE,
];
export function canManageIntegrations(permissions) {
    return INTEGRATION_MANAGEMENT_PERMISSIONS.some((permission) => permissions.includes(permission));
}
export const QUOTE_PERMISSION_EXPLICIT = "org:quotes:explicit";
export const REMITO_PERMISSION_EXPLICIT = "org:remitos:explicit";
export const PURCHASE_ORDER_PERMISSION_EXPLICIT = "org:purchase_orders:explicit";
export const STOCK_MOVEMENT_PERMISSION_EXPLICIT = "org:stock_movements:explicit";
export const PRODUCT_COST_PERMISSION_EXPLICIT = "org:product_costs:explicit";
export const ACTION_PERMISSIONS = {
    VIEW_PRODUCT_COSTS: "org:action:view_product_costs",
    VIEW_EXPECTED_CASH: "org:action:view_expected_cash",
    EDIT_DASHBOARD: "org:action:edit_dashboard",
    DELETE_SALES: "org:action:delete_sales",
    DELETE_CUSTOMERS: "org:action:delete_customers",
    DELETE_SUPPLIERS: "org:action:delete_suppliers",
    HIDE_ORDER_AMOUNTS: "org:action:hide_order_amounts",
    PREPARACION_PICK_WITHOUT_BARCODE_SCAN: "org:action:preparacion_pick_without_barcode_scan",
};
export const FEATURES_CONFIG = [
    {
        feature: "sales",
        label: "Ventas",
        hasRead: true,
        hasWrite: true,
        hasExport: true,
    },
    {
        feature: "quotes",
        label: "Presupuestos",
        hasRead: true,
        hasWrite: true,
        hasExport: false,
    },
    {
        feature: "remitos",
        label: "Remitos",
        hasRead: true,
        hasWrite: true,
        hasExport: false,
    },
    {
        feature: "orders",
        label: "Pedidos",
        hasRead: true,
        hasWrite: true,
        hasExport: false,
    },
    {
        feature: "preparacion",
        label: "Preparación",
        hasRead: false,
        hasWrite: true,
        hasExport: false,
    },
    {
        feature: "products",
        label: "Productos",
        hasRead: true,
        hasWrite: true,
        hasExport: true,
    },
    {
        feature: "inventory",
        label: "Inventario",
        hasRead: true,
        hasWrite: true,
        hasExport: true,
    },
    {
        feature: "stock_movements",
        label: "Movimientos de stock",
        hasRead: true,
        hasWrite: true,
        hasExport: true,
    },
    {
        feature: "prices",
        label: "Precios",
        hasRead: true,
        hasWrite: true,
        hasExport: false,
    },
    {
        feature: "customers",
        label: "Clientes",
        hasRead: true,
        hasWrite: true,
        hasExport: true,
    },
    {
        feature: "purchases",
        label: "Compras",
        hasRead: true,
        hasWrite: true,
        hasExport: true,
    },
    {
        feature: "purchase_orders",
        label: "Órdenes de compra",
        hasRead: true,
        hasWrite: true,
        hasExport: false,
    },
    {
        feature: "suppliers",
        label: "Proveedores",
        hasRead: true,
        hasWrite: true,
        hasExport: true,
    },
    {
        feature: "contabilidad",
        label: "Contabilidad",
        hasRead: true,
        hasWrite: true,
        hasExport: true,
    },
    {
        feature: "treasury",
        label: "Tesorería",
        hasRead: true,
        hasWrite: true,
        hasExport: true,
    },
    {
        feature: "checks",
        label: "Cheques",
        hasRead: true,
        hasWrite: true,
        hasExport: true,
    },
    {
        feature: "transfers",
        label: "Transferencias entre ubicaciones",
        hasRead: true,
        hasWrite: true,
        hasExport: true,
    },
    {
        feature: "settings",
        label: "Configuración",
        hasRead: false,
        hasWrite: true,
        hasExport: false,
        writeLabel: "Parametrización total",
    },
    {
        feature: "import",
        label: "Importar",
        hasRead: false,
        hasWrite: true,
        hasExport: false,
        writeLabel: "Importar datos (ej: productos o clientes)",
    },
    {
        feature: "integrations",
        label: "Integraciones",
        hasRead: false,
        hasWrite: true,
        hasExport: false,
        writeLabel: "Autorizar integraciones conectadas",
    },
    {
        feature: "reports",
        label: "Reportes",
        hasRead: true,
        hasWrite: false,
        hasExport: true,
    },
];
export const REPORT_GROUPS_CONFIG = [
    {
        key: "impositivo",
        label: "Impositivo",
        permission: "org:reports_impositivo:read",
    },
    { key: "ventas", label: "Ventas", permission: "org:reports_ventas:read" },
    {
        key: "inventario",
        label: "Inventario",
        permission: "org:reports_inventario:read",
    },
    {
        key: "financieros",
        label: "Financieros",
        permission: "org:reports_financieros:read",
    },
];
export const ALL_ACTION_PERMISSION_KEYS = [
    ACTION_PERMISSIONS.VIEW_PRODUCT_COSTS,
    ACTION_PERMISSIONS.VIEW_EXPECTED_CASH,
    ACTION_PERMISSIONS.EDIT_DASHBOARD,
    ACTION_PERMISSIONS.DELETE_SALES,
    ACTION_PERMISSIONS.DELETE_CUSTOMERS,
    ACTION_PERMISSIONS.DELETE_SUPPLIERS,
];
export const ALL_FEATURE_PERMISSION_KEYS = Object.values(FEATURE_PERMISSIONS);
export const ALL_PERMISSION_KEYS = [...ALL_FEATURE_PERMISSION_KEYS, ...ALL_ACTION_PERMISSION_KEYS];
export const ACTION_PERMISSION_LABELS = {
    [ACTION_PERMISSIONS.VIEW_PRODUCT_COSTS]: "Ver costos",
    [ACTION_PERMISSIONS.VIEW_EXPECTED_CASH]: "Ver efectivo esperado al cierre de caja",
    [ACTION_PERMISSIONS.EDIT_DASHBOARD]: "Editar dashboard",
    [ACTION_PERMISSIONS.DELETE_SALES]: "Eliminar ventas",
    [ACTION_PERMISSIONS.DELETE_CUSTOMERS]: "Eliminar clientes",
    [ACTION_PERMISSIONS.DELETE_SUPPLIERS]: "Eliminar proveedores",
    [ACTION_PERMISSIONS.HIDE_ORDER_AMOUNTS]: "Ocultar montos en Pedidos (totales y subtotales)",
    [ACTION_PERMISSIONS.PREPARACION_PICK_WITHOUT_BARCODE_SCAN]: "Pickear sin escaneo de código de barras",
};
export function hasUsableRolePermission(permissions) {
    return permissions.some((permission) => permission !== QUOTE_PERMISSION_EXPLICIT &&
        permission !== REMITO_PERMISSION_EXPLICIT &&
        permission !== PURCHASE_ORDER_PERMISSION_EXPLICIT &&
        permission !== STOCK_MOVEMENT_PERMISSION_EXPLICIT &&
        permission !== PRODUCT_COST_PERMISSION_EXPLICIT);
}
export function resolveEffectivePermissionKeys(permissions) {
    const effective = new Set(permissions);
    // These operational features have no export permission. Do not let generic
    // export-to-read implications turn unsupported stored keys into authority.
    effective.delete("org:remitos:export");
    effective.delete("org:purchase_orders:export");
    for (const policy of [
        {
            marker: REMITO_PERMISSION_EXPLICIT,
            read: FEATURE_PERMISSIONS.REMITOS_READ,
            write: FEATURE_PERMISSIONS.REMITOS_WRITE,
            legacyRead: FEATURE_PERMISSIONS.SALES_READ,
            legacyWrite: FEATURE_PERMISSIONS.SALES_WRITE,
            legacyExport: FEATURE_PERMISSIONS.SALES_EXPORT,
        },
        {
            marker: PURCHASE_ORDER_PERMISSION_EXPLICIT,
            read: FEATURE_PERMISSIONS.PURCHASE_ORDERS_READ,
            write: FEATURE_PERMISSIONS.PURCHASE_ORDERS_WRITE,
            legacyRead: FEATURE_PERMISSIONS.PURCHASES_READ,
            legacyWrite: FEATURE_PERMISSIONS.PURCHASES_WRITE,
            legacyExport: FEATURE_PERMISSIONS.PURCHASES_EXPORT,
        },
    ]) {
        if (!effective.has(policy.marker)) {
            effective.delete(policy.read);
            effective.delete(policy.write);
            if (effective.has(policy.legacyRead) ||
                effective.has(policy.legacyWrite) ||
                effective.has(policy.legacyExport)) {
                effective.add(policy.read);
            }
            if (effective.has(policy.legacyWrite)) {
                effective.add(policy.write);
            }
        }
        if (effective.has(policy.write)) {
            effective.add(policy.read);
        }
    }
    const quotePolicyIsExplicit = effective.has(QUOTE_PERMISSION_EXPLICIT);
    if (!quotePolicyIsExplicit) {
        effective.delete(FEATURE_PERMISSIONS.QUOTES_READ);
        effective.delete(FEATURE_PERMISSIONS.QUOTES_WRITE);
        if (effective.has(FEATURE_PERMISSIONS.SALES_READ) ||
            effective.has(FEATURE_PERMISSIONS.SALES_WRITE) ||
            effective.has(FEATURE_PERMISSIONS.SALES_EXPORT)) {
            effective.add(FEATURE_PERMISSIONS.QUOTES_READ);
        }
        if (effective.has(FEATURE_PERMISSIONS.SALES_WRITE)) {
            effective.add(FEATURE_PERMISSIONS.QUOTES_WRITE);
        }
    }
    if (effective.has(FEATURE_PERMISSIONS.QUOTES_WRITE)) {
        effective.add(FEATURE_PERMISSIONS.QUOTES_READ);
    }
    const stockMovementPolicyIsExplicit = effective.has(STOCK_MOVEMENT_PERMISSION_EXPLICIT);
    if (!stockMovementPolicyIsExplicit) {
        if (effective.has(FEATURE_PERMISSIONS.INVENTORY_READ) ||
            effective.has(FEATURE_PERMISSIONS.INVENTORY_WRITE) ||
            effective.has(FEATURE_PERMISSIONS.INVENTORY_EXPORT)) {
            effective.add(FEATURE_PERMISSIONS.STOCK_MOVEMENTS_READ);
        }
        if (effective.has(FEATURE_PERMISSIONS.INVENTORY_WRITE)) {
            effective.add(FEATURE_PERMISSIONS.STOCK_MOVEMENTS_WRITE);
        }
        if (effective.has(FEATURE_PERMISSIONS.INVENTORY_EXPORT)) {
            effective.add(FEATURE_PERMISSIONS.STOCK_MOVEMENTS_EXPORT);
        }
    }
    if (effective.has(FEATURE_PERMISSIONS.STOCK_MOVEMENTS_WRITE) ||
        effective.has(FEATURE_PERMISSIONS.STOCK_MOVEMENTS_EXPORT)) {
        effective.add(FEATURE_PERMISSIONS.STOCK_MOVEMENTS_READ);
    }
    return Array.from(effective);
}
